// Styles.
import { ModalStyles } from "../styles/components/ModalStyles";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
}) => {
  if (!isOpen) return null;

  return (
    <ModalStyles>
      <div className={className || "modal-contact-us"}>
        <button onClick={onClose}>Cerrar</button>
        {children}
      </div>
    </ModalStyles>
  );
};

export default Modal;
